module.exports = __webpack_public_path__ + "static/Zscaler-d0a13e0bf604d327f64e2de52a8e8f5f.jpg";